module.exports = __webpack_public_path__ + "static/img/compare.dab1db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/compare.png
// module id = qR4V
// module chunks = 192